import { styled } from '@innowise-group/mui-kit';
import { LabeledCheckbox } from '@shared-mui-components';
import {
  DictionaryCandidatePreofferInfoDiff,
  EmployeeDtoCandidatePreofferInfoDiff,
  BooleanCandidatePreofferInfoDiff,
  OrgUnitCandidatePreofferInfoDiff,
  PrimitiveFieldsDiff,
  EnumCandidatePreofferInfoDiff,
  isOutsideHrmDiff,
} from '../../../diff-variants';

const DEFAULT_DIFF_TOP_POSITION = 'top: 0px;';

export const GroupFieldsContainer = styled.div`
  position: relative;
  grid-column: 1 / span 4;
  display: grid;
  column-gap: 1.75rem;
  row-gap: 0.625rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: stretch;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    column-gap: 1.25rem;
    row-gap: 0.5rem;
  }
`;

export const BoxForDiffConsolidation = styled.div`
  position: relative;
  display: grid;
`;

export const CustomCheckbox = styled(LabeledCheckbox)`
  &.MuiCheckbox-root {
    margin: 10px 0;
  }
`;

export const CustomIsOutsideHrmDiff = styled(isOutsideHrmDiff)`
  top: 30px;
`;

export const CustomPrimitiveFieldsDiff = styled(PrimitiveFieldsDiff)`
  ${DEFAULT_DIFF_TOP_POSITION}
`;

export const CustomBooleanCandidatePreofferInfoDiff = styled(BooleanCandidatePreofferInfoDiff)`
  top: -8px;
`;

export const CustomEnumCandidatePreofferInfoDiff = styled(EnumCandidatePreofferInfoDiff)`
  ${DEFAULT_DIFF_TOP_POSITION}
`;

export const CustomDictionaryCandidatePreofferInfoDiff = styled(DictionaryCandidatePreofferInfoDiff)`
  ${DEFAULT_DIFF_TOP_POSITION}
`;

export const CustomOrgUnitCandidatePreofferInfoDiff = styled(OrgUnitCandidatePreofferInfoDiff)`
  ${DEFAULT_DIFF_TOP_POSITION}
`;

export const CustomEmployeeDtoCandidatePreofferInfoDiff = styled(EmployeeDtoCandidatePreofferInfoDiff)`
  ${DEFAULT_DIFF_TOP_POSITION}
`;

export const CommentWrapper = styled.div`
  position: relative;
  grid-column: 1 / -1;

  & .MuiTextField-root {
    width: 100%;
  }
`;
